import { environment } from '../environments/environment.dev';

export class AppSettings {
  public static API_URI = environment.backend;
  public static API_URI_V2 = environment.backend_v2;
  public static API_CHATBOT = environment.chatbot;
  public static API_LOGIN = environment.login;
  public static MEDIA_URI = environment.media;
  public static FRONT = environment.front;
  public static SALES = environment.sales;
  public static DEBUG = environment.debug;
  public static KEYS = environment.keys;
  public static WP_API = environment.wp_api;
  public static ENV_TOTEM = environment.totem;
  public static WALLET = environment.wallet;
  public static USER_TOTEM = environment.user_totem;
  public static PASS_TOTEM = environment.pass_totem;
}
